module.exports = __webpack_public_path__ + "img/LMI_Partner.5d2687f9.jpg";